import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState,
  VFC,
} from "react";
import { YMaps, Placemark, Map, Clusterer } from "react-yandex-maps";

import { PVZItem } from "src/pages/Checkout/elements/ChooseDelivery/types";

import {
  CloseButton,
  CloseIcon,
  ModalTitle,
  SelectButton,
  ShopModal,
  WorkTime,
  WorkTimeBox,
  WorkTimeTitle,
} from "./SdekMap.styles";

type IProps = {
  pvzList: PVZItem[];
  setPvz: Dispatch<SetStateAction<PVZItem | null>>;
};

const SdekMap: VFC<IProps> = ({ pvzList, setPvz }) => {
  // без any не работают ф-ии setBounds и setZoom
  const mapRef = useRef<any>(); //  eslint-disable-line @typescript-eslint/no-explicit-any

  const [bounds, setBounds] = useState<number[][]>([]);
  const [isOpenModal, setOpenModal] = useState<boolean>(false);
  const [currentShop, setCurrentShop] = useState<PVZItem | null>(null);

  const mapState = {
    center: [55.76, 37.64],
    zoom: 10,
    controls: ["zoomControl", "fullscreenControl"],
  };

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current
        .setBounds(bounds, { checkZoomRange: true })
        .then(() => mapRef.current.setZoom(9));
    }
  }, [bounds]);

  return (
    <div style={{ position: "relative", width: "100%", height: "100%" }}>
      <YMaps
        query={{
          lang: "ru_RU",
          apikey: "df639532-a255-4e82-b3e0-06ad7483393e",
        }}
      >
        <Map
          defaultState={mapState}
          width="100%"
          height="100%"
          modules={[
            "control.ZoomControl",
            "control.FullscreenControl",
            "util.bounds",
          ]}
          instanceRef={(ref) => {
            if (ref) {
              mapRef.current = ref;
            }
          }}
          onLoad={(ymaps) => {
            const points = pvzList.map((itemShop) => [
              itemShop.latitude,
              itemShop.longitude,
            ]);
            setBounds(ymaps.util.bounds.fromPoints([...points]));
          }}
        >
          <Clusterer
            options={{
              preset: "islands#invertedGreenClusterIcons", // Настройте внешний вид кластеров
              groupByCoordinates: false, // Группировать точки с одинаковыми координатами
              clusterDisableClickZoom: true, // Отключить увеличение при клике на кластер
              clusterHideIconOnBalloonOpen: false, // Скрывать иконку кластера при открытии балуна
              geoObjectHideIconOnBalloonOpen: false, // Скрывать иконку метки при открытии балуна
            }}
          >
            {pvzList.map((itemShop, index) => (
              <Placemark
                key={index}
                modules={["geoObject.addon.balloon"]}
                geometry={[
                  Number(itemShop.latitude),
                  Number(itemShop.longitude),
                ]}
                options={{
                  iconColor: "green",
                }}
                properties={{
                  balloonContentBody: itemShop.address,
                }}
                onClick={(e: MouseEvent) => {
                  e.preventDefault();
                  setOpenModal(true);
                  setCurrentShop(itemShop);
                }}
              />
            ))}
          </Clusterer>
        </Map>
      </YMaps>
      {isOpenModal && currentShop && (
        <ShopModal>
          <CloseButton onClick={() => setOpenModal(false)}>
            <CloseIcon />
          </CloseButton>
          <ModalTitle>{currentShop.address}</ModalTitle>
          <WorkTimeBox>
            <WorkTimeTitle>Время работы:</WorkTimeTitle>
            <WorkTime>
              {currentShop.work_time && currentShop.work_time.split(",")[0]}
            </WorkTime>
            <WorkTime>
              {currentShop.work_time && currentShop.work_time.split(",")[1]}
            </WorkTime>
          </WorkTimeBox>
          <SelectButton onClick={() => setPvz(currentShop)}>
            Выбрать
          </SelectButton>
        </ShopModal>
      )}
    </div>
  );
};

export default SdekMap;
